"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeDiscountTaxRatesBreakdown = exports.computeTaxRatesFromTotals = exports.computeExclTaxFromInclTax = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var big_numbers_1 = require("../../utils/big-numbers");
var filter_fees_1 = require("../fees/filter-fees");
var initialize_price_values_1 = require("../mappers/initialize-price-values");
var computeCumulativeTaxRates = function (items) {
    var taxRatesArray = [];
    var taxRatesMap = new Map();
    items.forEach(function (item) {
        var currentRate = taxRatesMap.get(item.taxRate) ? taxRatesMap.get(item.taxRate) : (0, initialize_price_values_1.initPricesRounded)();
        taxRatesMap.set(item.taxRate, {
            totalInclTax: currentRate.totalInclTax + item.totalPriceRounded.totalInclTax,
            totalExclTax: currentRate.totalExclTax + item.totalPriceRounded.totalExclTax,
            totalTax: currentRate.totalTax + item.totalPriceRounded.totalTax,
            totalInclTaxWithRemise: currentRate.totalInclTaxWithRemise + item.totalPriceRounded.totalInclTaxWithRemise,
            totalExclTaxWithRemise: currentRate.totalExclTaxWithRemise + item.totalPriceRounded.totalExclTaxWithRemise,
            totalTaxWithRemise: currentRate.totalTaxWithRemise + item.totalPriceRounded.totalTaxWithRemise,
            totalInclTaxWithDiscount: currentRate.totalInclTaxWithDiscount + item.totalPriceRounded.totalInclTaxWithDiscount,
            totalExclTaxWithDiscount: currentRate.totalExclTaxWithDiscount + item.totalPriceRounded.totalExclTaxWithDiscount,
            totalTaxWithDiscount: currentRate.totalTaxWithDiscount + item.totalPriceRounded.totalTaxWithDiscount,
        });
    });
    taxRatesMap.forEach(function (value, key) {
        taxRatesArray.push({ taxRate: key, totalPrice: value });
    });
    return taxRatesArray;
};
var sumTaxRateBreakdowns = function (taxRateBreakdowns) {
    var taxRatesArray = [];
    var taxRatesMap = new Map();
    taxRateBreakdowns.forEach(function (item) {
        var currentRate = taxRatesMap.get(item.taxRate)
            ? taxRatesMap.get(item.taxRate)
            : {
                totalInclTax: 0,
                totalExclTax: 0,
                totalTax: 0,
                totalInclTaxWithRemise: 0,
                totalExclTaxWithRemise: 0,
                totalTaxWithRemise: 0,
                totalInclTaxWithDiscount: 0,
                totalExclTaxWithDiscount: 0,
                totalTaxWithDiscount: 0,
            };
        Object.keys(currentRate).forEach(function (key) {
            currentRate[key] += item.totalPrice[key];
        });
        taxRatesMap.set(item.taxRate, currentRate);
    });
    taxRatesMap.forEach(function (value, key) {
        taxRatesArray.push({ taxRate: key, totalPrice: value });
    });
    return taxRatesArray;
};
var computeExclTaxFromInclTax = function (inclTax, taxRate) {
    return inclTax.dividedBy(big_numbers_1.big1.plus(new bignumber_js_1.default(taxRate).dividedBy(big_numbers_1.big10000)));
};
exports.computeExclTaxFromInclTax = computeExclTaxFromInclTax;
var computeTaxRatesFromTotals = function (products, fees) {
    var productsTaxBreakdownRounded = computeCumulativeTaxRates(products);
    var admissionsTaxBreakdownRounded = computeCumulativeTaxRates((0, filter_fees_1.filterTurnoverFees)(fees));
    var royaltiesTaxBreakdownRounded = computeCumulativeTaxRates((0, filter_fees_1.filterOffTurnoverFees)(fees));
    var taxRatesRounded = sumTaxRateBreakdowns(__spreadArray(__spreadArray(__spreadArray([], productsTaxBreakdownRounded, true), admissionsTaxBreakdownRounded, true), royaltiesTaxBreakdownRounded, true));
    return taxRatesRounded;
};
exports.computeTaxRatesFromTotals = computeTaxRatesFromTotals;
var computeDiscountTaxRatesBreakdown = function (items) {
    var taxRatesArray = [];
    var taxRatesMap = new Map();
    items.forEach(function (item) {
        var currentRate = taxRatesMap.get(item.taxRate) ? taxRatesMap.get(item.taxRate) : (0, initialize_price_values_1.initPricesNotRounded)();
        var totalInclTax = currentRate.totalInclTax.plus(item.discountedAmountInclTax);
        var totalExclTax = currentRate.totalExclTax.plus(item.discountedAmountExclTax);
        taxRatesMap.set(item.taxRate, {
            totalInclTax: totalInclTax,
            totalExclTax: totalExclTax,
            totalInclTaxWithRemise: totalInclTax,
            totalExclTaxWithRemise: totalExclTax,
            totalInclTaxWithDiscount: totalInclTax,
            totalExclTaxWithDiscount: totalExclTax,
        });
    });
    taxRatesMap.forEach(function (value, key) {
        taxRatesArray.push({ taxRate: key, totalPrice: value });
    });
    return taxRatesArray;
};
exports.computeDiscountTaxRatesBreakdown = computeDiscountTaxRatesBreakdown;
